module.exports = __webpack_public_path__ + "static/media/jammu&kashmir.4d414101.png";